import React from 'react';
import type TravelerInformation from '@this/src/domain/traveler_information';
import type OrderItem from '@this/src/domain/order_item2';
import ContentInfo from './content_info';

interface Props {
  item: OrderItem;
  traveler: TravelerInformation;
  total: number;
  type: string;
}

const NormalContent: React.FC<Props> = ({ item, traveler, total, type }) => {
  // TODO: findでいいの？全件回す必要ありそう？
  const orderItemMapping = item.orderItemMappings.find(mapping => mapping.travelerInformationId === traveler.id);
  if (!orderItemMapping) {
    return null;
  }
  if (type === 'department' && orderItemMapping.chargingDepartmentShareId) {
    return null;
  }
  if (type === 'project' && orderItemMapping.projectShareId) {
    return null;
  }

  const price = (item.price?.price ?? 0) + (item.price?.margin?.amount ?? 0);
  const amount = price / (total || 1);
  const bufferAmount = item.bufferAmount / (total || 1);

  let itemName = '';
  if (type === 'department') {
    itemName = orderItemMapping.chargingDepartment?.descriptionWithCode() || '';
  } else if (type === 'project') {
    itemName = orderItemMapping.project?.codeAndName() || '';
  } else if (type === 'account') {
    itemName = `${orderItemMapping.expensesAccountType?.code}:${orderItemMapping.expensesAccountType?.name}`;
  }

  return (
    <ContentInfo
      item={item}
      traveler={traveler}
      price={amount}
      bufferAmount={bufferAmount}
      itemName={itemName}
      index={traveler.id}
    />
  );
};

export default NormalContent;
